
import { Clipboard } from '@angular/cdk/clipboard';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Annotation } from '../../common/models/Annotation';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { ConfirmDialogComponent } from '../../common/shared-components/confirm-dialog/confirm-dialog.component';
import { constObj } from '../../common/Constants/constants';
import { HttpcallService } from '../../common/services/httpcall.service';
import { Router } from '@angular/router';
import { SessionService } from '../../common/services/Session.service';

@Component({
  selector: 'app-my-annotations',
  templateUrl: './my-annotations.component.html',
  styleUrls: ['./my-annotations.component.css']
})

export class MyAnnotationsComponent implements OnInit, AfterViewInit {
  public displayedColumns = ['AnnotationTitle', "Annotation", 'ParagraphId', 'Date', 'Action'];
  public dataSourceCod = new MatTableDataSource<myAnnotations>();
  public dataSourceOP = new MatTableDataSource<myAnnotations>();
  public dataSourceCIG = new MatTableDataSource<myAnnotations>();
  res: myAnnotations[];
  paragraphId: string = "";
  currentRoute: string;
  userId: string;
  mailId: string;
  IsBookmark: boolean;
  pagesize: any = 10;
  actualresult: any;
  pagelistarrayCod: any[] = [];
  pagelistarrayOP: any[] = [];
  pagelistarrayCIG: any[] = [];
  Annotationheader: any;
  annotationcolumnone: any;
  annotationcolumntwo: any;
  annotationcolumnthree: any;
  annotationcolumnfour: any;
  annotationcolumnfive: any;
  AnotationLocation: any;
  annotationContent: any = [];
  navData = {
    crumbData: [],
    menuData: [],
  }
  accordionRows: any[] = [];
  leftNavmenuLevel = [1, 2, 3]
  noRecords = constObj.Norecords;
  @ViewChild('TableOneSort', { static: true }) sortCod: MatSort;
  @ViewChild('TableTwoSort', { static: true }) sortOP: MatSort;
  @ViewChild('TableThreeSort', { static: true }) sortCIG: MatSort;
  @ViewChild('TableOnePaginator', { static: true }) paginatorCod: MatPaginator;
  @ViewChild('TableTwoPaginator', { static: true }) paginatorOP: MatPaginator;
  @ViewChild('TableThreePaginator', { static: true }) paginatorCIG: MatPaginator;
  constructor(
    private graphQlService: GraphqlService, private httpCallService: HttpcallService, private route: Router, private session: SessionService,
    public commonDataService: CommonDataService, private loginService: LoginService, private clipboard: Clipboard, public dialog: MatDialog) { }

  ngOnInit() {
    this.getUserId();
    this.commonDataService.myannotation.subscribe(data => {
      if (data == "annotations") {
        this.commonDataService.showLoader.next(true);
        this.getAnnotationsData();
      }
    });
    this.getmyAnnotationsLabel();

  }

  public redirectToDetails = (id: string) => {

  }

  getmyAnnotationsLabel() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.Annotationheader = labels.filter(x => x.key == "myAnnotations_header").map(y => y.value);
        this.annotationcolumnone = labels.filter(x => x.key == "myBookmarks_columnOne").map(y => y.value);
        this.annotationcolumntwo = labels.filter(x => x.key == "global_annotation").map(y => y.value);
        this.annotationcolumnthree = labels.filter(x => x.key == "global_location").map(y => y.value);
        this.annotationcolumnfour = labels.filter(x => x.key == "global_date").map(y => y.value)[0];
        this.annotationcolumnfive = labels.filter(x => x.key == "global_action").map(y => y.value);
      }
    });
  }
  public copyToClipboard = (URL: string, desc: string, location1: string[], paragraph: string) => {
    let span = document.createElement('span');
    span.innerHTML = location1.join(' -> ').split("____")[0];
    let AnnotationLocation = span.innerText.trim().replace(/\s+/g, " ");
    this.clipboard.copy("Annotation: " + desc + "\nLink: " + location.origin + URL + "\nLocation: " + AnnotationLocation);

    let obj = {
      type: 'success',
      displayTime: 5000,
      position: 'bottom',
      message: constObj.linkSharedMessage
    }
    this.commonDataService.notificationObject.next(obj);
  }
  redirectToDelete(id: string) {
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: constObj.annotationDeletionConfirmationPromptMessage
    });
    var annotation = this.actualresult.filter(x => x.id == id)[0];
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commonDataService.isConfirmationPopUpOpen.next(false);
        this.commonDataService.showLoader.next(true);
        var deleteAnnotation: Annotation = {
          id: annotation.id, topicId: annotation.topicId, paragraphId: annotation.paragraphId, annotationTitle: annotation.annotationTitle,
          annotationDescription: annotation.annotationDescription, 
          application: "", createdOn: annotation.createdOn, modifiedOn: "", breadCrumb: annotation.breadCrumb, isDeleted: true, annotationsURL: annotation.annotationsURL,
          area: annotation.area, navigationPath: annotation.navigationPath
        }
        this.httpCall(deleteAnnotation);
      }
    });
  }
  ngAfterViewInit(): void {
    this.dataSourceCod.sort = this.sortCod;
    this.dataSourceCod.paginator = this.paginatorCod;
    this.dataSourceOP.sort = this.sortOP;
    this.dataSourceOP.paginator = this.paginatorOP;
    this.dataSourceCIG.sort = this.sortCIG;
    this.dataSourceCIG.paginator = this.paginatorCIG;
  }
  getAnnotationsData() {
    this.accordionRows = ["Codification", "Original Pronouncements", "Comprehensive Implementation Guide"];//data.filter((el, i) => this.leftNavmenuLevel.some(j => i === j)).map(y => y.item)
    this.httpCallService.getAnnotation(this.paragraphId, "true").subscribe((resp: any) => {
      this.annotationContent = resp;
      this.actualresult = resp;
      if (this.actualresult[0]) {
        this.AnotationLocation = this.actualresult[0].breadCrumb;
      }
      var ress = this.actualresult.map(x => ({ id: x.id, AnnotationTitle: x.annotationTitle, Annotation: x.annotationDescription, Location: x.breadCrumb.split("~"), Date: new Date(x.createdOn), ParagraphId: x.paragraphId, AnnotationsURL: x.annotationsURL, LeftNavOrigin: x.breadCrumb.split("~")[0] }))
      this.filterAccordianrows(ress);
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  getUserId() {
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.commonDataService.userId.next(data.user.userName);
        this.commonDataService.mailId.next(data.user.email);
        this.userId = data.user.userName;
        this.mailId = data.user.email;
        this.getAnnotationsData();
      })
    }
    else {
      this.userId = this.session.userInfo.user.userName;
      this.mailId = this.session.userInfo.user.email;
      this.getAnnotationsData();
    }
  }
  httpCall(annotation: Annotation) {
    this.httpCallService.addUpdateAnnotation(annotation).toPromise()
      .then(response => {
        if (response == "Annotation added successfully.") {
          let obj = {
            type: 'success',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedSuccessMessage
          }
          this.commonDataService.notificationObject.next(obj);
          this.commonDataService.deleteAnnotationParagraphId.next(annotation.paragraphId);
          this.removeAnnotationFromArray(annotation);
        }
        else {
          let obj = {
            type: 'error',
            displayTime: 5000,
            position: 'bottom',
            message: constObj.annotationRemovedFailMessage
          }
          this.commonDataService.notificationObject.next(obj);
          //this.removeAnnotationFromArray(annotation);
        }
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }
  removeAnnotationFromArray(annotation: Annotation) {
    this.annotationContent = this.annotationContent.filter(x => x.id != annotation.id);
    var ress = this.annotationContent.map(x => ({ id: x.id, AnnotationTitle: x.annotationTitle, Annotation: x.annotationDescription, Location: x.breadCrumb.split("~"), Date: new Date(x.createdOn), ParagraphId: x.paragraphId, AnnotationsURL: x.annotationsURL, LeftNavOrigin: x.breadCrumb.split("~")[0] }))
    this.filterAccordianrows(ress)
    this.commonDataService.showLoader.next(false);
  }
  filterAccordianrows(ress) {
    for (let item of this.accordionRows) {
      var data: any;
      if (item == "Original Pronouncements" || item == "Comprehensive Implementation Guide") {
        data = ress.filter(x => x.LeftNavOrigin == item);
      } else {
        data = ress.filter(x => (x.LeftNavOrigin != "Original Pronouncements") && (x.LeftNavOrigin != "Comprehensive Implementation Guide"));
      }
      if (item == "Codification") {
        this.dataSourceCod.data = data as myAnnotations[];
        this.pagelistarrayCod = []
        for (let i = 10; i <= data.length + 10; i = i + 10) {
          this.pagelistarrayCod.push(i);
        }
      }
      else if (item == "Original Pronouncements") {
        this.dataSourceOP.data = data as myAnnotations[];
        this.pagelistarrayOP = []
        for (let i = 10; i <= data.length + 10; i = i + 10) {
          this.pagelistarrayOP.push(i);
        }
      }
      else if (item == "Comprehensive Implementation Guide") {
        this.dataSourceCIG.data = data as myAnnotations[];
        this.pagelistarrayCIG = []
        for (let i = 10; i <= data.length + 10; i = i + 10) {
          this.pagelistarrayCIG.push(i);
        }
      }
    }
  }
  editAnnotations(id: string) {
    var annotation = this.annotationContent.filter(x => x.id == id);
    this.commonDataService.showRightPanel.next(true);
    var breadcrumb = annotation[0].breadCrumb.split('~')
    this.navData.crumbData = [];
    for (var i = 0; i < breadcrumb.length; i++) {
      this.navData.crumbData.push(breadcrumb[i]);
    }
    this.commonDataService.breadcrumbPath.next(breadcrumb);
    this.commonDataService.navDataContentPage.next(this.navData.crumbData);
    this.commonDataService.annotationUpdateSource.next("MyAnnotation");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.currentParagraphId.next("Edit Annotation Id");
    this.commonDataService.annotationContent.next(annotation[0]);
    this.commonDataService.rightOverlayOption.next("Add Annotation");
  }

  NavigateTo(url, id) {
    if ((!url?.startsWith("/") && url?.split("/").length < 3) || (url?.startsWith("/") && url?.split("/").length <= 3)) {
      url = "/" + url?.split("/")[1] + "/" + url?.split("/")[2] + "/" + id;
    }
    this.route.navigateByUrl(url);
  }
}

export interface myAnnotations {
  id: string
  AnnotationTitle: string;
  Annotation: string;
  Location: string;
  Date: Date;
  ParagraphId: string;
  AnnotationsURL: string;
  LeftNavOrigin: string;
}
